import React from "react";
import { BrandAccents } from "../components/BrandAccents";
import { ContactBar } from "../components/ContactBar";
import { Countdown } from "../components/Countdown";
import { GraderScene } from "../components/GraderScene";
import { Logo } from "../components/Logo";
import { NotifyForm } from "../components/NotifyForm";
import { ServicesStrip } from "../components/ServicesStrip";
export function ComingSoon() {
  return <main className="relative min-h-screen w-full overflow-hidden bg-brand-charcoal font-body text-brand-white" data-id="element-63" data-mp="d9xjz0r7ls3v">
      <GraderScene data-id="element-64" data-mp="99err5lemk15" />
      <BrandAccents data-id="element-65" data-mp="97u6y7ow6fgh" />

      <div className="relative z-10 flex min-h-screen flex-col" data-id="element-66" data-mp="n0s5u40jmpos">
        <header className="px-6 pt-7 sm:px-10 lg:px-16 lg:pt-10" data-id="element-67" data-mp="n3604anefxva">
          <Logo data-id="element-68" data-mp="i39xofucoehu" />
        </header>

        <section className="flex flex-1 items-center px-6 py-10 sm:px-10 lg:px-16 lg:py-12" data-id="element-69" data-mp="i41rbl4e025h">
          <div className="w-full max-w-[680px]" data-id="element-70" data-mp="wx52nardxjnr">
            <p className="text-[11px] font-medium uppercase tracking-[0.42em] text-brand-white/85 sm:text-sm" data-id="element-71" data-mp="s0xtza7ltu24">
              Building a stronger tomorrow
            </p>

            <h1 className="mt-5 font-display font-expanded font-extrabold uppercase leading-[0.95]" data-id="element-72" data-mp="125380cu5kq2i">
              <span className="block text-[24px] text-brand-white sm:text-[34px] lg:text-[44px]" data-id="element-73" data-mp="166y5t7cvklbj">Our new website is</span>
              <span className="mt-1 block text-[38px] text-brand-red sm:text-[56px] lg:text-[74px]" data-id="element-74" data-mp="1b61c0v4lcxl3">Coming soon</span>
            </h1>

            <p className="mt-6 max-w-[500px] text-base leading-relaxed text-brand-white/90 sm:text-[17px]" data-id="element-75" data-mp="1g4cjiz7eyw05">
              We’re working hard to bring you a better online experience. Stay tuned for updates, project showcases and
              more.
            </p>

            <div className="mt-7 flex max-w-[580px] items-center" aria-hidden="true" data-id="element-76" data-mp="1twirvz4bryp1">
              <span className="h-[3px] w-14 bg-brand-red" data-id="element-77" data-mp="1yvvnp9d6cg3r" />
              <span className="h-px flex-1 bg-brand-red/35" data-id="element-78" data-mp="1yt96ei0hem8c" />
            </div>

            <div className="mt-7" data-id="element-79" data-mp="23uyg9ubywtuu">
              <Countdown data-id="element-80" data-mp="3s730q3ydcuh" />
            </div>

            <div className="mt-9" data-id="element-81" data-mp="3t8nfl6uzbov">
              <NotifyForm data-id="element-82" data-mp="3q4fqdu6pxtg" />
            </div>
          </div>
        </section>

        <ServicesStrip data-id="element-83" data-mp="3v035mvtp2wt6" />
        <ContactBar data-id="element-84" data-mp="3uwnmnhwwh3mh" />
      </div>
    </main>;
}